import { z } from 'zod';
import { calendarDateSchema } from '@/features/listing-filters/calendarDate';

export const EXECUTION_MODES = ['Full', 'PersistOnly', 'DryRun'] as const;
export const DATA_SOURCE_NAMESPACES = ['Owl', 'Yak'] as const;

/**
 * Filters only. Pagination here is cursor-based and stays in component state:
 * a cursor is meaningless once the filters change, and saving one would restore
 * a page that no longer exists.
 */
export const executionsFiltersSchema = z.object({
  emitterId: z.array(z.string().min(1)).optional().catch(undefined),
  templateId: z.array(z.string().min(1)).optional().catch(undefined),
  status: z
    .array(z.enum(['Pending', 'Running', 'Completed', 'Failed', 'Cancelled']))
    .optional()
    .catch(undefined),
  executionMode: z.array(z.enum(EXECUTION_MODES)).optional().catch(undefined),
  dataSourceNamespace: z.array(z.enum(DATA_SOURCE_NAMESPACES)).optional().catch(undefined),
  search: z.string().min(1).optional().catch(undefined),
  hasResults: z.literal(true).optional().catch(undefined),
  hasNewResults: z.literal(true).optional().catch(undefined),
  startDate: calendarDateSchema.optional().catch(undefined),
  endDate: calendarDateSchema.optional().catch(undefined),
});

// URL only, never saved: a saved chain would reopen one chain's chunks on every later visit.
export const executionsSearchSchema = executionsFiltersSchema.extend({
  chainRootId: z.string().min(1).optional().catch(undefined),
});

export type ExecutionsFilterValues = z.infer<typeof executionsSearchSchema>;
